module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/stretchlab-5c5e23c1e53a1d813cb395ba18a56e61.png";